
import "./Home.css";
import Navbar from "./navbar";
import emailjs from '@emailjs/browser';
import React, { useRef } from 'react';


function Contact(){
    const form = useRef();
    const nameField = document.getElementById('name');
    const emailField = document.getElementById('email');
    const messageField = document.getElementById('message');


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
        .sendForm('service_bj0t0m6', 'template_zkqb5zh', form.current, {
            publicKey: 'bsRvZSd6AAk-A8lRT',
        })
        .then(
            () => {
        
                
                console.log('SUCCESS!');
                alert("email sent - thank you for reaching out1");


            },
                (error) => {
                console.log('FAILED...', error.text);
            },
        );
    };
    
     
    return(
        <div className="entireContactPageContainer">
        <Navbar />
       
       <div className="contactContent">
            
                <div className="formBox">

                    
                    <form className="emailForm" id="form" ref={form} onSubmit={sendEmail}>
                     
                        <div id="contactTitle">contact</div>
                       
                        <input type="text" name="name" id="name" placeholder="name" />
                        
                        <input type="email" name="email" id="email" placeholder="email" />
                        
                        <textarea name="message" id="message" placeholder="message" />
                        <input className="submitButton" type="submit" value="Send" />
                    </form>
                </div>
            </div>
            </div>
    );
}

export default Contact;